import { Button, Center, Stack, Textarea } from "@chakra-ui/react"
import { ChangeEvent, FC, useCallback, useEffect, useState } from "react"

import useAllKeysPress from "@shared/hooks/useAllKeysPress"
import { formatXML } from "@shared/lib/xml/format-xml"
import CodeBlock from "@shared/ui/code-block"
import ValidationIndicator from "@shared/ui/validation-indicator"

const placeholder = "<root><node/></root>"

const XMLPretty: FC = () => {
  const [rawInput, setRawInput] = useState("")
  const [prettyOut, setPrettyOut] = useState("")
  const [isValid, setIsValid] = useState(false)
  const [isProcessed, setIsProcessed] = useState(false)
  const processPressed = useAllKeysPress({ userKeys: ["Control", "Enter"] })

  const handleSubmit = useCallback(() => {
    const result = formatXML(rawInput)

    setPrettyOut(result.result)
    setIsValid(!result.errors)
    setIsProcessed(true)
  }, [rawInput])

  useEffect(() => {
    if (processPressed) {
      handleSubmit()
    }
  }, [processPressed, handleSubmit])

  const onChangeInput = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setRawInput(e.target.value)
  }

  return (
    <Stack>
      <Textarea
        placeholder={placeholder}
        value={rawInput}
        onChange={onChangeInput}
        isInvalid={Boolean(rawInput && !isValid)}
        rows={8}
      />
      <Center>
        <Button onClick={handleSubmit} mt={2} disabled={!rawInput}>
          Process
        </Button>
      </Center>
      {isProcessed && (
        <>
          <ValidationIndicator isValid={isValid} />
          {isValid && <CodeBlock code={prettyOut} language={"xml"} />}
        </>
      )}
    </Stack>
  )
}

export default XMLPretty
